var {AmpersandState, AmpersandCollection} = require('catalog/libs');
var HPELog = require('core/log');

var HPEServices = require('../../base/hpe.services');
var HPEConstants = require('../../base/hpe.constants');
var ProductModel = require('../../base/hpe.product.model');

/**
 * collection of product models, each representing a compare item
 */
var CatalogCompareListCollection = AmpersandCollection.extend({
    mainIndex: 'oid',
    model: ProductModel.ProductBaseModel
});

/**
 * compare list model
 */
module.exports = AmpersandState.extend({

    /**
     * initialization
     * when instantiating pass a "path" value that represents path to current page context
     */
    initialize: function() {

        if (window.sessionStorage) {

            //event bindings
            this.onItemAdd = this.itemAdd.bind(this);
            this.onItemRemove = this.itemRemove.bind(this);
            this.onNavigateToComparePage = this.navigateToComparePage.bind(this);

            //path is a key stored with tray contents - if the stored path
            //does not match current path of page, the tray is initialized but not populated
            //do not initialize unless current path can be determined
            if (this.path && this.path !== '') {

                //path might need contextual modification before use
                this.path = this.preparePathString(this.path);

                //if no compare path is supplied during initialization, use the base path
                if (!this.comparePath) {
                    this.comparePath = this.path;
                }

                //populate list in memory with any data from storage
                this.initializeListFromStorage();

                //event handlers
                HPEServices.subscribe(HPEConstants.catalog.COMPARE_LIST_REMOVE, this, this.onItemRemove);
                HPEServices.subscribe(HPEConstants.catalog.COMPARE_LIST_ADD, this, this.onItemAdd);
                HPEServices.subscribe(HPEConstants.catalog.COMPARE_PAGE_NAVIGATE, this, this.onNavigateToComparePage);
            } else {
                HPELog.error('[Products]: Compare list invalid path');
            }
        }
    },

    /**
     * collections
     */
    collections: {
        items: CatalogCompareListCollection
    },

    /**
     * props
     */
    props: {
        oidList: ['array', false, function() { return []; }],
        storedPath: 'string',
        path: 'string',
        comparePath: 'string',
        originPath: 'string'
    },

    /**
     * populate the model + list collection with data (if exists) retrieved from storage
     * storage exists only a single category "path" only and will be overwritten if user
     * saves values with a different path
     */
    initializeListFromStorage: function() {

        // var that = this;
        var storedValues = window.sessionStorage.getItem(HPEConstants.catalog.COMPARE_STORAGE_KEY);

        //proceed only if stored values exist
        if (storedValues) {

            //parse serialized values, save local copy of stored path string
            storedValues = JSON.parse(storedValues);
            this.storedPath = storedValues.path;
            this.originPath = storedValues.originPath;

            //proceed only if stored values applicable to the current path
            //if paths do not match, storedValues will persist until user adds an item to compare
            //list from a different category, at which time the storage will be overwritten with
            //values set to that path
            if (this.storedPath === this.path) {

                //save each item retrieved from storage to collection
                if (storedValues && storedValues.list && storedValues.list.length) {
                    storedValues.list.map(this.addItemToCollection.bind(this));
                }
            }
        }

        //update oid list to match storage list
        this.oidListUpdate();

        //broadcast change event
        HPEServices.publish(HPEConstants.catalog.COMPARE_LIST_CHANGE, {
            originPath: this.originPath,
            oidList: this.oidList
        });
    },

    /**
     * update storage with latest version of collection
     * @return {boolean} true or false if persistence update successful
     */
    persistChanges: function() {

        var sessionData = {};
        var isSuccess = false;

        if (this.items.length) {

            //initialize data session object
            sessionData.list = [];
            sessionData.path = this.path;

            //create origin path from path and local data
            sessionData.originPath = window.location.protocol + '//' + window.location.host + this.path;
            if (!sessionData.originPath.match(/.html$/)) {
                sessionData.originPath += '.html';
            }

            //add each compare item to session object
            this.items.forEach(function(item) {
                sessionData.list.push({
                    oid: item.oid,
                    prodname: item.prodname,
                    prodnameurl: item.prodnameurl,
                    produrl: item.produrl,
                    updated: item.updated,
                    'new': item['new']
                });
            });

            //try to save session object
            try {
                window.sessionStorage.setItem(HPEConstants.catalog.COMPARE_STORAGE_KEY, JSON.stringify(sessionData));
                isSuccess = true;
            } catch (e) {
                isSuccess = false;
            }

        //remove stored data
        } else {
            try {
                window.sessionStorage.removeItem(HPEConstants.catalog.COMPARE_STORAGE_KEY);
                isSuccess = true;
            } catch (e) {
                isSuccess = false;
            }
        }

        //return success boolean
        if (isSuccess) {

            //after each change to the list of compare items, update list of oids to match
            this.oidListUpdate();

            //broadcast change event
            HPEServices.publish(HPEConstants.catalog.COMPARE_LIST_CHANGE, {
                originPath: sessionData.originPath,
                oidList: this.oidList
            });

            return true;
        } else {
            return false;
        }
    },

    /**
     * add the passed item to the compare tray
     * @param {object} item object representing a product with required key/value pairs
     */
    itemAdd: function(item) {

        //do not exceed the maximum number of items saved
        if (this.items.length < HPEConstants.catalog.COMPARE_COUNT_MAX) {
            this.addItemToCollection(item);
            this.persistChanges();
        } else {
            HPELog.log('hpe compare list full');
        }
    },

    /**
     * remove the passed item from the compare list
     * @param {string} oid id of the item to remove
     */
    itemRemove: function(oid) {

        var removedItem;

        //remove the item at index oid
        if (oid) {

            removedItem = this.items.remove(oid);

            //on successful remove, save changes and broadcast UI remove event
            if (removedItem) {
                this.persistChanges();
                HPEServices.publish(HPEConstants.catalog.COMPARE_TRAY_REMOVE, oid);

            //item not in collection so remove directly from session storage
            } else {
                this.itemRemoveFromSession(oid);
            }
        }
    },

    /**
     * remove the passed item from persisted list
     * @param {string} oid id of the item to remove
     */
    itemRemoveFromSession: function(oid) {

        var newValues;
        var storedValues = window.sessionStorage.getItem(HPEConstants.catalog.COMPARE_STORAGE_KEY);

        //proceed only if stored values exist
        if (storedValues) {

            //parse serialized values, save local copy of stored path string
            newValues = {};
            storedValues = JSON.parse(storedValues);
            newValues.originPath = storedValues.originPath;
            newValues.path = storedValues.path;

            newValues.list = storedValues.list.filter(function(item) {
                return item.oid !== oid;
            });

            //try to save session object
            try {
                window.sessionStorage.setItem(HPEConstants.catalog.COMPARE_STORAGE_KEY, JSON.stringify(newValues));
            } catch (e) {
                HPELog.error('[Products]: Compare session remove error');
            }
        }
    },

    /**
     * add the passed item to the collection of products
     * @param {object} item object with product properties
     */
    addItemToCollection: function(item) {

        //ensure minimum required parameters for saving
        if (item && item.oid && item.prodname && item.produrl) {
            this.items.add({
                oid: item.oid,
                prodname: item.prodname,
                produrl: item.produrl,
                prodnameurl: item.prodnameurl,
                'new': item.new,
                updated: item.updated
            });

            //broadcast item add/available event
            HPEServices.publish(HPEConstants.catalog.COMPARE_TRAY_ADD, item);
        }
    },

    /**
     * maintain a model property list of just the oids that are currently in the compare list
     * list cannot be derived property due to collection updates
     */
    oidListUpdate: function() {

        if (this.items.length) {
            this.oidList = this.items.map(function(item) {
                return item.oid;
            });
        } else {
            this.oidList = [];
        }
    },

    /**
     * handle compare navigation event: create url to compare page and redirect browser to location
     */
    navigateToComparePage: function() {

        var url = '/compare';
        var that = this;

        //create url to compare by iterating through compare item list and creating selectors
        //from oid and product name values
        //example url: compare.oid-123.oid-456.oid-789.html
        // url was shortened for HPED-3671
        url = this.items.reduce(function(selectorString, item) {
            return selectorString += '.oid-' + item.oid;
        }, url);

        //finalize url formatting
        if (url && url.length) {

            //build out fully qualified absolute url
            url = window.location.protocol + '//' + window.location.host + that.comparePath + url + '.html';

            //redirect
            window.location.href = url;

        } else {
            HPELog.debug('[Products]: Could not create compare url');
        }
    },

    /**
     * paths are inconsistent from AEM, so preprocess path value before use
     * @param {string} path path string to sanitize
     * @return {string} formatting path string
     */
    preparePathString: function(path) {

        var selectorParts;
        var modelsId = 'models';

        //remove trailing ".compare" if present
        path = path.replace(/.compare$/, '');

        //try to determine if this is a PLP or PDP path (provided inconsistent path values)
        //if a PDP path, we want to munge the path to become of type "models", because only
        //that path supports compare tray, but the backend supplied path may or may not include
        //the "models" type since user may enter the PDP from any "tab" type (or no tab type at all)
        selectorParts = path.split('.');

        //break apart path, add/update models tab type, re-consitute path
        if (selectorParts && selectorParts.length && (selectorParts[selectorParts.length - 1] === 'html')) {
            if (selectorParts.indexOf(modelsId) === -1) {
                if (selectorParts.length === 5) {
                    selectorParts[1] = modelsId;
                } else if ((selectorParts.length === 3) || (selectorParts.length === 4)) {
                    selectorParts.splice(1, 0, modelsId);
                }
            }
            path = selectorParts.join('.');
        }

        //when data contains no productname, sometimes paths supplied by AEM have double
        //period selector separators where productname is missing -- try to trap for these
        //to ensure paths match when they should even if missing productname
        path = path.replace(/\.\./, '.');

        return path;
    }
});
